import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ScrollToTop from './components/ScrollToTop';

import AffiliateLandingPage from './pages/affiliate/AffiliateLandingPage';
import AffiliateApplyPage from './pages/affiliate/AffiliateApplyPage';
import AffiliateLoginPage from './pages/affiliate/AffiliateLoginPage';
import AffiliateDashboardPage from './pages/affiliate/AffiliateDashboardPage';
import AdminAffiliatesPage from './pages/AdminAffiliatesPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import ContactPage from './pages/ContactPage';

/**
 * Axon Muscle Affiliate Program — single-purpose React app.
 *
 * Deployed at: affiliate.axonmuscle.com
 *
 * Routes:
 *   /                  Landing
 *   /apply             Signup form (full)
 *   /login             Affiliate login
 *   /dashboard         Affiliate dashboard (auth required)
 *   /admin/affiliates  Admin moderation (ADMIN_TOKEN required)
 *   /privacy /terms /contact
 */
function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<AffiliateLandingPage />} />
        <Route path="/apply" element={<AffiliateApplyPage />} />
        <Route path="/login" element={<AffiliateLoginPage />} />
        <Route path="/dashboard" element={<AffiliateDashboardPage />} />

        {/* Admin moderation — ADMIN_TOKEN-gated */}
        <Route path="/admin" element={<Navigate to="/admin/affiliates" replace />} />
        <Route path="/admin/affiliates" element={<AdminAffiliatesPage />} />

        {/* Legal & contact */}
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/contact" element={<ContactPage />} />

        {/* Anything else → landing */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
